import { notification } from "antd";
import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFeedStatsPerformFilters, getDataFeedStatsPerformMatchId } from "store/dataFeed/actions.js";

import styles from "./DatafeedFilters.module.scss";
import FilterColumn from "./FilterColumn.js";

function DatafeedFilters({
  streamId,
  filters,
  setFilters,
  getDataFeedStatsPerformMatchId,
  getDataFeedStatsPerformFilters,
}) {
  const getData = useCallback(
    async (filters) => {
      try {
        const matchIdResponse = await getDataFeedStatsPerformMatchId({ streamId });
        if (matchIdResponse.error) {
          throw new Error(matchIdResponse.error.message);
        }
        if (!matchIdResponse?.payload?.data) {
          throw new Error("No matchId found");
        }

        const matchId = matchIdResponse.payload.data?.matchId;

        const response = await getDataFeedStatsPerformFilters({
          matchId,
          ...filters,
        });
        if (response.error) {
          throw new Error(response.error.message);
        }
        const data = response.payload.data;
        const dataWithChecked = Object.keys(data).reduce(
          (acc, filter) => ({
            ...acc,
            [filter]: data[filter].map((item) => ({
              ...item,
              checked: (filters[filter] || []).includes(item.value) || false,
            })),
          }),
          {},
        );

        setFilters(dataWithChecked);
      } catch (error) {
        console.error(error);
        notification.error({ message: error.message });
      }
    },
    [getDataFeedStatsPerformFilters, getDataFeedStatsPerformMatchId, setFilters, streamId],
  );

  useEffect(() => {
    getData({
      appealId: [],
      batterHand: [],
      batterId: [],
      batterRuns: [],
      battingConnection: [],
      battingShotType: [],
      boundary: [],
      bowlerHand: [],
      bowlerId: [],
      bowlingFrom: [],
      bowlingLength: [],
      bowlingLine: [],
      bowlingType: [],
      bye: [],
      fielderId: [],
      freeHit: [],
      legBye: [],
      noBall: [],
      outcomeId: [],
      wideOfCrease: [],
    });
  }, [getData]);

  const oldFilterRef = React.useRef();

  const areFiltersCheckedEqual = useCallback((oldFilters, newFilters) => {
    return Object.keys(oldFilters).every((filter) => {
      return oldFilters[filter].every((item, index) => {
        return item.checked === ((newFilters[filter] || {})[index] || {}).checked;
      });
    });
  }, []);

  useEffect(() => {
    if (oldFilterRef.current) {
      if (!areFiltersCheckedEqual(oldFilterRef.current, filters)) {
        getData(
          Object.keys(filters).reduce(
            (acc, filter) => ({
              ...acc,
              [filter]: filters[filter].filter((item) => item.checked).map((item) => item.value),
            }),
            {},
          ),
        );
      }
    }
    oldFilterRef.current = filters;
  }, [areFiltersCheckedEqual, filters, getData]);

  return (
    <div className={styles.datafeedContainer}>
      {Object.keys(filters).map((filter) => {
        return (
          <FilterColumn
            key={filter}
            filterName={filter}
            checked={(filters[filter] || []).reduce(
              (acc, { value, checked }) => ({ ...acc, [value]: checked || false }),
              {},
            )}
            onReset={() => {
              setFilters((prevFilters) => ({
                ...prevFilters,
                [filter]: prevFilters[filter].map((item) => ({ ...item, checked: false })),
              }));
            }}
            onChange={(value, checked) =>
              setFilters((prevFilters) => ({
                ...prevFilters,
                [filter]: prevFilters[filter].map((item) => (item.value === value ? { ...item, checked } : item)),
              }))
            }
            list={filters[filter]}
          />
        );
      })}
    </div>
  );
}

const mapDispatchToProps = {
  getDataFeedStatsPerformMatchId,
  getDataFeedStatsPerformFilters,
};

export default connect(null, mapDispatchToProps)(DatafeedFilters);
